export const SET_BREADCRUMB_LABEL = "SET_BREADCRUMB_LABEL";
export const RESET_BREADCRUMB_LABELS = "RESET_BREADCRUMB_LABELS";
